(ns ycweb.app.dashboard.orders
  (:require
    [ycweb.components.flow :as flow]
    [rum.core :as rum]
    [ycweb.util.core :as u]
    [ycweb.util.urlstate :as urlstate]
    [ycweb.components.common :as cmn]
    [ycweb.components.grid :as grid]
    [ycweb.components.transitions :as t]
    [ycweb.components.forms :as forms]
    [ycweb.app.dashboard.orderview :as orderview]
    [ycweb.app.dashboard.common :as dcommon]
    [ycweb.app.admin.common :as acommon]
    [ycweb.app.dashboard.presence :as presence]
    [ycweb.util.comms :as comms]
    [ycweb.util.date :as ud]
    [util.string :as str]
    [inflections.core :as inflections]
    [clojure.set :as set]
    ;; TODO: need to sort these date libraries out.. this shouldn't be necessary.
    #?@(:clj
        [[clj-time.core :as dt]
         [clj-time.coerce :as dtc]]
        :cljs
        [[cljs-time.core :as dt]
         [cljs-time.coerce :as dtc]])
    [clojure.edn :as edn]))

;; TODO: Filtering on the top of the order tables, by name/yc number
;; TODO: Rewrite the "Ready Later" link to guide you through the process of setting the min ships

(defn update-orders [app-atom orders]
  (let [update-index (u/index-by :id orders)]
    (swap! app-atom update-in [:dashboard :orders]
      (fn [orderlist]
        (map
          (fn [o]
            (merge o (get update-index (:id o))))
          orderlist)))))

(defn dynamic-stat-breakdown [breakdown]
  (map
    (fn [keyword]
      {:title
       (->
         keyword
         name
         str/capitalize
         (str/replace #"-" " "))
       :qty (get breakdown keyword 0)})
    (keys breakdown)))

(defn stats [{:keys [status-lookup stats tags]} current-page]
  [{:title "Yellows"
    :qty (reduce (fn [acc [_ qty]] (+ acc qty)) 0 (get-in stats [:burndown-breakdown :cs]))
    :breakdown
    (dynamic-stat-breakdown (get-in stats [:burndown-breakdown :cs]))
    :url
    (if (= current-page :order)
      "/admin/burndown.htm"
      "/admin/index-new.htm#order/dashboard?")
    :color-class :yellow}

   {:title "Orders to Process"
    :qty (reduce (fn [acc [_ qty]] (+ acc qty)) 0 (get-in stats [:burndown-breakdown :finance]))
    :breakdown
    (dynamic-stat-breakdown (get-in stats [:burndown-breakdown :finance]))
    :url "/admin/burndown.htm"
    :color-class :blue}

   {:title "Aftersales"
    :qty (reduce (fn [acc [_ qty]] (+ acc qty)) 0 (get-in stats [:burndown-breakdown :aftersales]))
    :breakdown
    (dynamic-stat-breakdown (get-in stats [:burndown-breakdown :aftersales]))
    :url "/admin/index-new.htm#aftersales/dashboard?"
    :color-class :mustard}

   #_{:title "POPs" :qty ":: 23" :oldest 156.1
    :url "/admin/csprocess.htm?action=pop"
    :age-threshold 2}

   #_{:title "Unpaids" :qty ":: 171" :oldest 201.2
    :url "/admin/csprocess.htm?action=unpaid"
    :age-threshold 4}

   #_{:title "Failed" :qty ":: 256" :oldest 844.7
    :url "/admin/csprocess.htm?action=failedpaid"
    :age-threshold 1}

   {:title "Fraud"
    :qty (get-in stats [:tags "Fraud Check" :qty])
    :url "/admin/csprocess.htm?action=fraud"
    :text-pill (str "Oldest: " (u/number-format (get-in stats [:tags "Fraud Check" :oldest]) 1) " hours")
    :warning?
    (and
      (get-in stats [:tags "Fraud Check" :oldest])
      (> (get-in stats [:tags "Fraud Check" :oldest]) 2))}

   {:title "Instructions"
    :qty (get-in stats [:tags "Special Instructions" :qty])
    :url "/admin/csprocess.htm?action=instructions"
    :warning?
    (and
      (get-in stats [:tags "Special Instructions" :oldest])
      (> (get-in stats [:tags "Special Instructions" :oldest]) 2))}

   {:title "Orders Shipped" :qty (:deliveries stats)}])

(rum/defc stats-blocks < rum/reactive [app-atom]
  (let [stats (stats (cmn/curact app-atom [:dashboard]) :order)]
    [:section.admin-stats
     (into
       [:div {:class (u/bem :flex-grid-group [:flush])}]
       (map acommon/stats-block stats))]))

(rum/defc action-item
  [app-atom toggle-fn foldout
   {:keys [id title qty load-action unload-action detail-body-fn]}]
  (let [opened? (contains? foldout id)]
    [:section.admin-action-item
     [:header.admin-action-item__header
      [:span.admin-action-item__icon [:i {:class (u/bem :icon [:is-dark :label :block])}]]
      [:h2.admin-action-item__title title]

      [:p.admin-action-item__count-wrapper
       (when qty
         [:span.admin-action-item__count qty])]

      (cond
        opened?
        [:a.admin-action-item__link.js-hide-dashboard-link
         {:on-click
          (fn []
            (toggle-fn id false)
            (when unload-action
              (grid/dispatch-action app-atom unload-action {})))}
         [:i.js-load-dashboard-icon {:class (u/bem :icon [:is-dark :minus :block])}]]

        :else
        [:a.admin-action-item__link.js-load-dashboard-link
         {:on-click
          (fn []
            (toggle-fn id true)
            (when load-action
              (grid/dispatch-action app-atom load-action {})))}
         [:i.js-load-dashboard-icon {:class (u/bem :icon [:is-dark :plus :block])}]])]

     (when (and opened? detail-body-fn)
       [:div.admin-action-item__content (detail-body-fn id)])]))

(rum/defc action-section [{:keys [title items]}]
  (into
    [:section.admin-action-list
     [:h2.admin-action-list__section-title title]]
    (remove nil? items)))

(rum/defc refresh-button < rum/reactive [app-atom]
  (let [{:keys [busy count total]} (cmn/curact app-atom [:dashboard :refreshing])]
    [:a.alertonly
     {:class (u/bem :button [:default :raised :primary])
      :on-click #(grid/dispatch-action app-atom :order/refresh-list {})}
     (if busy
       (str "Refreshing..."
         (if count (str " " count " / " total)))
       (str
         "Refresh"
         (if total (str " - " (inflections/pluralize total "order")))))]))

(rum/defc ordersearch-input [app-atom]
  [:div {:class "text-input-wrapper"}
   (forms/input-raw "Search" (rum/cursor-in app-atom [:dashboard :ordersearch]) {:class "text-input"})])

(rum/defc productsearch-input < rum/reactive [app-atom]
  [:div {:class "text-input-wrapper"}
   (forms/input-raw
     "Search product id   "
     (rum/cursor-in app-atom [:dashboard :productsearch :contentid])
     {:class     "text-input"})])

(defmethod comms/receive :order/product-order-list [app-atom {:keys [orderids contentid] :as e}]
  (swap! app-atom update-in [:dashboard :productsearch]
    (fn [p]
      (if (= (:contentid p) contentid)
        (assoc p :orderids orderids)
        p))))

(defmethod grid/action :order/refresh-list [app-atom config _]
  (swap! app-atom assoc-in [:dashboard :refreshing] {:busy true})
  (comms/send :order/list {}))

(defonce loading-orders (atom []))

(defmethod comms/receive :order/list
  [app-atom {:keys [orders tags type-lookup status-lookup stats watchlist] :as e}]
  (reset! loading-orders [])
  (swap! app-atom update :dashboard
    (fn [d]
      (assoc d
        :refreshing
        {:busy true :count (count (:list orders))
         :total (:total orders)
         :requuid (:requuid orders)}
        :tags tags
        :watchlist watchlist
        :type-lookup type-lookup
        :status-lookup
        (merge status-lookup
          (->>
            status-lookup
            (map (fn [[nm id]] [id nm]))
            (into {})))
        :loading (:list orders)
        :stats
        (assoc-in stats
          [:burndown-breakdown :aftersales]
          (:aftersales (:burndown-breakdown (:stats d))))))))

(defmethod comms/receive :order/list-add
  [app-atom {:keys [page total requuid] :as e}]
  (when
    (= requuid (get-in @app-atom [:dashboard :refreshing :requuid]))

    (swap! loading-orders (fn [existing] (concat existing (:list e))))
    (swap! app-atom update-in [:dashboard :refreshing :count]
      (fnil + 0 0) (count (:list e)))))

(defmethod comms/receive :order/list-finished-loading
  [app-atom {:keys [page total requuid] :as e}]
  (when
    (= requuid (get-in @app-atom [:dashboard :refreshing :requuid]))
    (swap! app-atom update :dashboard
      (fn [d]
        (->
          d
          (assoc-in [:refreshing :busy] false)
          ;; Ungroup everything - doesn't hold up with refresh.
          (update :orderlist
            (fn [o]
              (->>
                o
                (map (fn [[k v]] [k (dissoc v :grouping)]))
                (into {}))))
          (assoc :orders @loading-orders))))
    (reset! loading-orders [])))

(defn local-order-filter [{:keys [yellows-only text] :as flt} o]
  (and
    (or
      (and yellows-only (:yellow o))
      (not yellows-only))

    (or
      (not (u/presence text))
      (and (u/presence text)
        (str/includes?
          (str/lower-case (str (:firstname o) " " (:lastname o) " " (:site o) (:id o) " " (:invoice o)))
          (str/lower-case text))))))

(defn local-product-order-filter [{:keys [yellows-only orderids] :as flt} o]
  (some (set orderids) (set [(:id o)]))

  (and
    (or
      (and yellows-only (:yellow o))
      (not yellows-only))

    (not-empty orderids)
    (some (set orderids) (set [(:id o)]))))

(rum/defc tag-item < rum/static [tag yellowcount ordercount toggle-fn]
  [:tr
   [:th.th-section-header.collapseSegment
    {:colSpan 9 :on-click #(toggle-fn tag) :style {:cursor "pointer"}}
    (:name tag)
    " (" yellowcount " / " ordercount ")"]])

(rum/defc pagination-control < rum/reactive [page-atom pagecount]
  (let [{:keys [page pagesize]} (rum/react page-atom)
        page (or page 0)]
    (when (> pagecount 1)
      [:div
       [:p {:class "form-label  u-text-center"}
        "Page " (inc page) " of " pagecount]
       [:div {:class (u/bem :flex-grid-group [:fluid :valign-middle])}
        [:div {:class (u/bem :flex-grid-block [:fluid])}
         [:div {:class "flex-grid-content"}
          [:a
           {:class (u/bem :button [(if (> page 1) :primary :disabled) :default :raised] :alertonly)
            :on-click (when (> page 1) #(swap! page-atom assoc :page 0))}
           "<<"]]]

        [:div {:class (u/bem :flex-grid-block [:fluid])}
         [:div {:class "flex-grid-content"}
          [:a
           {:class (u/bem :button [(if (pos? page) :primary :disabled) :default :raised] :alertonly)
            :on-click (when (pos? page) #(swap! page-atom assoc :page (dec page)))}
           "<"]]]

        [:div {:class (u/bem :flex-grid-block [:fluid])}
         [:div {:class "flex-grid-content"}
          [:a
           {:class (u/bem :button [(if (< (inc page) pagecount) :primary :disabled) :default :raised] :alertonly)
            :on-click (when (< (inc page) pagecount) #(swap! page-atom assoc :page (inc page)))}
           ">"]]]

        [:div {:class (u/bem :flex-grid-block [:fluid])}
         [:div {:class "flex-grid-content"}
          [:a
           {:class (u/bem :button [(if (< (inc page) (dec pagecount)) :primary :disabled) :default :raised] :alertonly)
            :on-click (when (< (inc page) (dec pagecount)) #(swap! page-atom assoc :page (dec pagecount)))}
           ">>"]]]]])))

(rum/defc ordertable [lines shipqty futureshipqty]
  [:table {:class (u/bem :oTable [:has-shadow])}
   [:thead
    [:tr
     [:th]
     [:th "Order ID"]
     [:th "Name"]
     [:th "Queue Date"]
     [:th "Sleep Date"]
     [:th.u-text-right "Income"]
     [:th "Status"]
     [:th "Lead time"]
     [:th]]]
   (into
     [:tbody]
     lines)

   [:tfoot
    [:tr
     [:td {:colSpan 9 :bgcolor "#eeeeee"}
      (str shipqty)
      (if (pos? futureshipqty)
        (str " (+ Future Ship: " futureshipqty ")"))]]]])

(rum/defc group-item < rum/static [tag yellowcount ordercount toggle-fn]
  [:tr
   [:th.th-section-header.collapseSegment
    {:colSpan 9 :on-click #(toggle-fn tag) :style {:cursor "pointer"}}
    [:div {:style {:background-color (:fg tag) :float "left" :width "16px" :height "16px" :margin-right "5px" :border (str "1px solid " (:bg tag))}} " "]
    (:name tag)
    " (" yellowcount " / " ordercount ")"]])

(defn orderlines-statusgroupview
  [app-atom orderlist-settings orders status-lookup show-essentials-level? integrate open-order-fn]
  (let [
        {grouping :grouping
         opened-orders :opened}
        (rum/react orderlist-settings)
        open-groups (:opened grouping)

        group-orders
        (->>
          orders
          (group-by (juxt (comp :priority :shippingstatus) (comp :group :shippingstatus) (comp :status :shippingstatus))))

        groups
        (->>
          (keys group-orders)
          (sort)
          (map
            (fn [[p g k :as key]]
              (let [info (orderview/shippingstatus-info {:status k :group g})]
                {:name (:title info) :group g :key key :fg (:fg info) :bg (:bg info)}))))

        toggle-group
        (fn [group]
          (swap! orderlist-settings update-in [:grouping :opened]
            (fnil
              #((if (contains? % (:key group)) disj conj) %
                (:key group))
              #{})))

        opened-groups (if (nil? open-groups) #{} open-groups)]
    (->>
      groups
      (mapcat
        (fn [group]
          (let [tagorders (get group-orders (:key group))]
            (concat
              [(group-item group (count (filter :yellow tagorders)) (count tagorders) toggle-group)]

              (when (contains? opened-groups (:key group))
                (map
                  #(orderview/orderlist-item % status-lookup show-essentials-level? integrate
                     (contains? opened-orders (:id %)) open-order-fn)
                  tagorders)))))))))

(defn orderlines-tagview
  [app-atom orderlist-settings
   orders status-lookup show-essentials-level? integrate open-order-fn]
  (let [{opened-tags :tags
         opened-orders :opened}
        (rum/react orderlist-settings)

        tagorders
        (->>
          orders
          (mapcat
            (fn [o]
              (cond
                (empty? (:tagids o))
                [(assoc o :tagid nil)]
                :else
                (map #(assoc o :tagid %) (:tagids o)))))
          (group-by :tagid))

        tags
        (conj
          (->>
            (cmn/curact app-atom [:dashboard :tags])
            vals
            (sort-by :name)
            vec)
          {:tagid nil :name "Untagged"})

        toggle-tag
        (fn [tag]
          (swap! orderlist-settings update :tags
            (fnil
              #((if (contains? % (:id tag)) disj conj) %
                (:id tag))
              #{})))

        opened-tags (if (nil? opened-tags) #{nil} opened-tags)]

    (->>
      tags
      (filter #(contains? tagorders (:id %)))
      (mapcat
        (fn [tag]
          (let [tagorders (get tagorders (:id tag))]
            (concat
              [(tag-item tag (count (filter :yellow tagorders)) (count tagorders) toggle-tag)]

              (when (contains? opened-tags (:id tag))
                (map
                  #(orderview/orderlist-item % status-lookup show-essentials-level? integrate
                     (contains? opened-orders (:id %)) open-order-fn)
                  tagorders)))))))))

(rum/defc orderlist-view < rum/reactive [app-atom tagged? filter-fn id]
  (let [status-lookup (cmn/curact app-atom [:dashboard :status-lookup])
        {:keys [shippinglevel]} (cmn/curact app-atom [:config :essentialgoods])
        show-essentials-level? (and shippinglevel (pos? shippinglevel))
        integrate (cmn/curact app-atom [:config :integrate])

        orderlist-settings (rum/cursor-in app-atom [:dashboard :orderlist id])
        {{:keys [yellows-only] :as flt} :flt
         grouping :grouping
         opened-orders :opened
         pages :pages :as settings}
        (rum/react orderlist-settings)

        filter-atom (rum/cursor-in orderlist-settings [:flt :text])

        page-orders
        (->>
          (cmn/curact app-atom [:dashboard :orders])
          (filter filter-fn))

        local-filtered-orders
        (filter (partial local-order-filter flt) page-orders)


        open-order-fn
        (fn [order open?]
          ;; Let's update proactively...
          (orderview/queue-detail-load (:id order) true)

          (swap! orderlist-settings update :opened
            (fnil (if open? conj disj) #{}) (:id order)))

        lines
        (cond
          (= :loaded (:status grouping))
          (orderlines-statusgroupview app-atom orderlist-settings local-filtered-orders
            status-lookup show-essentials-level?
            integrate open-order-fn)

          tagged?
          (orderlines-tagview app-atom orderlist-settings local-filtered-orders status-lookup show-essentials-level?
            integrate open-order-fn)

          :else
          (map
            #(orderview/orderlist-item % status-lookup show-essentials-level? integrate
               (contains? opened-orders (:id %)) open-order-fn)
            local-filtered-orders))

        [shipqty futureshipqty]
        (reduce
          (fn [acc o]
            (update acc
              (if (:future o) 1 0) inc))
          [0 0]
          page-orders)

        pagecount (u/ceil (/ (count lines) (:pagesize pages 100)))]

    (when (> (:page pages) pagecount)
      (swap! orderlist-settings assoc-in [:pages :page] 0))

    [:div.dashboardOrderList
     [:div {:class (u/bem :flex-grid-group [:flush :align-left :valign-bottom])}
      [:div {:class (u/bem :flex-grid-block [:ml-1-4])}
       [:div {:class "flex-grid-content"}
        [:label {:class "form-label"}
         "Filter: (by YC number or name)"]
        (forms/input-raw "Jane Smith..." filter-atom {:class "text-input"})]]

      [:div {:class (u/bem :flex-grid-block [:ml-2-4])}
       [:div {:class "flex-grid-content"}
        (pagination-control (rum/cursor orderlist-settings :pages) pagecount)]]

      [:div {:class (u/bem :flex-grid-block [:ml-1-4])}
       [:div {:class "flex-grid-content"}
        [:div {:class (u/bem :flex-grid-group [:flush :valign-middle :align-right])}
         [:div {:class (u/bem :flex-grid-block [:fluid])}
          [:div {:class "flex-grid-content"}
           (cond
             yellows-only
             [:a
              {:class (u/bem :button [:primary :small :raised] :showall)
               :on-click #(swap! orderlist-settings assoc-in [:flt :yellows-only] false)}
              "Show All"]

             :else
             [:a
              {:class (u/bem :button [:primary :small :raised] :alertonly)
               :on-click #(swap! orderlist-settings assoc-in [:flt :yellows-only] true)}
              "Show yellows only"])]]
         [:div {:class (u/bem :flex-grid-block [:fluid])}
          [:div {:class "flex-grid-content"}
           (case (:status grouping)
             :loading
             [:a
              {:class (u/bem :button [:secondary :bordered :small :raised] :showall)
               :on-click #(swap! orderlist-settings assoc-in [:grouping :status] :none)}
              "Loading"
              (if (and (:page grouping) (pos? (:page grouping)))
                (str " " (:page grouping) " / " (:pagecount grouping))
                "...")]

             :loaded
             [:a
              {:class (u/bem :button [:secondary :bordered :small :raised] :showall)
               :on-click #(swap! orderlist-settings assoc-in [:grouping :status] :none)}
              "Ungroup"]

             [:a
              {:class (u/bem :button [:secondary :bordered :small :raised] :showall)
               :on-click
               #(grid/dispatch-action app-atom :order/load-group
                                      {:orders local-filtered-orders :id id})}
              "Load Statuses and Group"])]]]]]]

     (ordertable
       (->>
         lines
         (drop (* (:page pages 0) (:pagesize pages 100)))
         (take (:pagesize pages 100)))
       shipqty futureshipqty)

     (pagination-control (rum/cursor orderlist-settings :pages) pagecount)]))

(defmethod grid/action :order/load-group [app-atom config _]
  (let [group-load
        (rum/cursor-in app-atom [:dashboard :orderlist (:id config) :grouping])]
    (swap! group-load assoc :status :loading :page 0 :pagecount 0)
    (comms/send :order/load-group
      {:id (:id config)
       :orderids
       (->>
         (:orders config)
         (remove :l)
         (map :id)
         (vec))})))

(defonce group-load-atom (atom []))

(defmethod comms/receive :order/load-group-progress [app-atom e]
  (swap! group-load-atom concat (:orders e))
  (swap! app-atom update-in [:dashboard :orderlist (:id e) :grouping]
    (fn [g]
      (assoc g :page (:page e) :pagecount (:pagecount e)))))

(defmethod comms/receive :order/load-group [app-atom e]
  (let [loaded @group-load-atom
        group-load (rum/cursor-in app-atom [:dashboard :orderlist (:id e) :grouping])]

    (update-orders app-atom loaded)
    (reset! group-load-atom [])
    (when (= :loading (:status @group-load))
      (swap! group-load assoc :status :loaded))))

(rum/defc order-sections < rum/reactive [app-atom]
  (let [stats (cmn/curact app-atom [:dashboard :stats])
        user (cmn/curact app-atom [:user])
        status-lookup (cmn/curact app-atom [:dashboard :status-lookup])
        tags (cmn/curact app-atom [:dashboard :tags])
        my-tags
        (->>
          tags
          vals
          (filter #(str/starts-with? (str/lower-case (:name % "")) (str/lower-case (:firstname user ""))))
          (map :id)
          set)

        ;; TODO: Yuuuuck.. surely we should load up the tags for a better direct lookup...
        packlane-tag
        (->>
          tags
          vals
          (filter #(= (:codename %) "Packlane Problems"))
          first)

        watchlist (cmn/curact app-atom [:dashboard :watchlist])

        my-watchlist (get watchlist (:refid user))
        foldout-state-atom (rum/cursor-in app-atom [:dashboard :foldout])

        foldout (or (rum/react foldout-state-atom) #{})

        toggle-fold
        (fn [n open?]
          (swap! foldout-state-atom (fnil (if open? conj disj) #{}) n))]
    (action-section
      {:title "Order Actions"
       :items
       (map
         (partial action-item app-atom toggle-fold foldout)
         (remove nil?
           [{:id "packlane-problems"
             :title "Ready to Ship - Packlane Problems"
             :qty (get-in stats [:tags "Packlane Problems" :qty])
             :detail-body-fn
             (partial
               orderlist-view app-atom false
               (fn [o]
                 (contains? (:tagids o) (:id packlane-tag))))}

            {:id "watchlist"
             :title "My Watchlist"
             :qty (count my-watchlist)
             :detail-body-fn
             (partial orderlist-view app-atom true
               (fn [o] (contains? my-watchlist (:id o))))}

            {:id "mytags"
             :title "My Tags"
             :qty (reduce (fnil + 0 0) 0 (vals (select-keys (:tag-breakdown stats) my-tags)))
             :detail-body-fn
             (partial orderlist-view app-atom true
               (fn [o] (not (empty? (set/intersection my-tags (:tagids o))))))}

            {:id "please-contact"
             :title "Please Contact"
             :qty (get-in stats [:status-breakdown (get status-lookup "Please Contact")] 0)
             :detail-body-fn
             (partial orderlist-view app-atom true
               (fn [o] (= (:status o) (get status-lookup "Please Contact"))))}

            (when (pos? (get-in stats [:status-breakdown (get status-lookup "Problem")] 0))
              {:id "problem"
               :title "Problem"
               :qty (get-in stats [:status-breakdown (get status-lookup "Problem")] 0)
               :detail-body-fn
               (partial orderlist-view app-atom true
                 (fn [o] (= (:status o) (get status-lookup "Problem"))))})

            {:id "followed-up"
             :title "Followed Up"
             :qty (get-in stats [:status-breakdown (get status-lookup "Followed Up")] 0)
             :detail-body-fn
             (partial orderlist-view app-atom true
               (fn [o] (= (:status o) (get status-lookup "Followed Up"))))}

            {:id "paid"
             :title "Paid"
             :qty (get-in stats [:status-breakdown (get status-lookup "Paid")] 0)
             :detail-body-fn
             (partial orderlist-view app-atom false
               (fn [o] (and (not (:readylater o)) (= (:status o) (get status-lookup "Paid")))))}

            {:id "ready-later"
             :title "Ready Later"
             :qty (get-in stats [:status-breakdown :readylater] 0)
             :detail-body-fn
             (partial orderlist-view app-atom false
               (fn [o] (and (:readylater o) (= (:status o) (get status-lookup "Paid")))))}

            {:id "ready-to-ship"
             :title "Ready to Ship"
             :qty (get-in stats [:status-breakdown (get status-lookup "Ready to Ship")] 0)
             :detail-body-fn
             (partial orderlist-view app-atom false
               (fn [o] (= (:status o) (get status-lookup "Ready to Ship"))))}

            #_{:id "aftersales"
               :title "Aftersales"
               :qty "::500"}

            #_{:id "registries-to-ship"
               :title "Registries to be shipped"
               :qty "::0"}]))})))

(rum/defc order-search < rum/reactive [app-atom ordersearch]
  (let [;; TODO: unify this pre-amble
        status-lookup (cmn/curact app-atom [:dashboard :status-lookup])
        {:keys [shippinglevel]} (cmn/curact app-atom [:config :essentialgoods])
        show-essentials-level? (and shippinglevel (pos? shippinglevel))
        integrate (cmn/curact app-atom [:config :integrate])

        orders
        (->>
          (cmn/curact app-atom [:dashboard :orders])
          (filter (partial local-order-filter {:text ordersearch}))
          (take 10))

        lines
        (map
          #(orderview/orderlist-item % status-lookup show-essentials-level? integrate
             true (fn [_]))
          orders)]
    (list
      [:span {:style {:margin-left "5px"}} (inflections/pluralize (count orders) "order")]
      (ordertable lines "" 0))))

(rum/defc product-search < rum/reactive [app-atom productsearch]
  (let [status-lookup (cmn/curact app-atom [:dashboard :status-lookup])
        {:keys [shippinglevel]} (cmn/curact app-atom [:config :essentialgoods])
        show-essentials-level? (and shippinglevel (pos? shippinglevel))
        integrate (cmn/curact app-atom [:config :integrate])
        orderids (cmn/curact app-atom [:dashboard :productsearch :orderids])

        orderlist-settings (rum/cursor-in app-atom [:dashboard :orderlist "product-search"])
        {opened-orders :opened}
        (rum/react orderlist-settings)

        open-order-fn
        (fn [order open?]
          (orderview/queue-detail-load (:id order) true)
          (swap! orderlist-settings update :opened
            (fnil (if open? conj disj) #{}) (:id order)))

        orders
        (->>
          (cmn/curact app-atom [:dashboard :orders])
          (filter (partial local-product-order-filter {:orderids orderids})))

        lines
        (map
          #(orderview/orderlist-item % status-lookup show-essentials-level? integrate
            (contains? opened-orders (:id %)) open-order-fn)
          orders)]
    (list
      [:span {:style {:margin-left "5px"}} (inflections/pluralize (count orders) "order")]
      (ordertable lines "" 0))))

(rum/defcs dashboard < rum/reactive (rum/local {:legend? false} ::state) [s app-atom]
  (let [local-atom (::state s)
        local-state (rum/react local-atom)
        ordersearch (cmn/curact app-atom [:dashboard :ordersearch])
        productsearch (cmn/curact app-atom [:dashboard :productsearch :contentid])]
    [:div
     (stats-blocks app-atom)
     [:div {:class (u/bem :flex-grid-group [:flush :valign-bottom :align-left])}
      [:div {:class (u/bem :flex-grid-block [:fluid])}
       [:div {:class "flex-grid-content"}
        [:label {:class "form-label"}
         "Filter: (by YC number or name)"]
        (ordersearch-input app-atom)]]

      [:div {:class (u/bem :flex-grid-block [:fluid])}
       [:div {:class "flex-grid-content"}
        [:label {:class "form-label"}
         "Filter by product id:"]
        (productsearch-input app-atom)]]

      [:div {:class (u/bem :flex-grid-block [:fluid])}
       [:div {:class "flex-grid-content"}
        (refresh-button app-atom)]]

      [:div {:class (u/bem :flex-grid-block [:fluid :align-right])}
       [:div {:class "flex-grid-content"}
        [:a
         {:on-click #(swap! local-atom update :legend? not)
          :class (u/bem :button [:default :raised :secondary :bordered])}
         "Toggle Legend"]]]]

     (when (:legend? local-state)
       (into
         [:ul {:class "status-legend-list"}]
         (map
           (fn [[k {:keys [fg bg title]}]]
             [:li {:class "status-legend-list-item  u-margin-bottom-10"}
              [:div {:style {:background fg} :class "status-legend-list-item__color-dot"} " "]
              [:span {:class "status-legend-list-item__text"} title]])

           (sort-by
             (comp :priority val )
             orderview/shipping-statuses))))

     (cond
       (u/presence ordersearch)
       (order-search app-atom ordersearch)

       (u/presence productsearch)
       (product-search app-atom productsearch)

       :else
       (order-sections app-atom))

     #_(action-section
         {:title "Stock Actions"
          :items
          (map (partial action-item app-atom toggle-fold foldout)
            [{:id "toorder"
              :title "To Order"}

             {:id "stockorder-noitems"
              :title "No Item Orders"
              :qty "::0"}])})

     #_(action-section
         {:title "Finance Actions"
          :items
          (map (partial action-item app-atom toggle-fold foldout)
            [{:id "invoice-not-paid"
              :title "Invoiced Not Paid"}

             {:id "delivered-not-paid"
              :title "Delivered No Payment"}])})

     #_(action-section
         {:title "Delivery Actions"
          :items
          (map (partial action-item app-atom toggle-fold foldout)
            [{:id "delivery.manifest"
              :title "Manifests"}

             {:id "delivery.postofficeready"
              :title "Ready for Post Office"
              :qty "::0"}

             {:id "delivery.awaitcollection"
              :title "Awaiting Collection/Hand"
              :qty "::124"}

             {:id "delivery.aramex"
              :title "Sent to Aramex"
              :qty "::1534"}

             {:id "delivery.rest"
              :title "Sent to the rest"
              :qty "::24"}

             {:id "delivery.notracking"
              :title "Delivered No Tracking"}])})]))

(defmethod flow/render-screen :order/dashboard [app-atom _]
  (dashboard app-atom))

(defmethod t/transition-open :order/dashboard [app-atom _ _]
  (let [foldout-state-atom (rum/cursor-in app-atom [:dashboard :foldout])]
    (urlstate/bind-nav-fragment foldout-state-atom "foldout" :set))

  ;; TODO: We need a 'menu' screen instead of just not loading the orders.
  ;;(comms/send :order/list {})
  (cmn/debounce-in app-atom [:dashboard :productsearch :contentid] 500
    (fn [contentid]
      (when (u/presence contentid)
        (comms/send :order/product-order-list {:contentid contentid}))))

  (presence/open app-atom
    {:context/ident :order/dashboard})
  (orderview/setup-detail-queue-bounce app-atom))

(defmethod t/transition-close :order/dashboard [app-atom _]
  (orderview/teardown-detail-queue-bounce app-atom))

(defmethod grid/action :order/open-dashboard [app-atom config _]
  (t/transition-next app-atom :order/dashboard))



(defmethod comms/receive :order/list-detail [app-atom {:keys [orders] :as e}]
  (update-orders app-atom orders))